module.exports = __webpack_public_path__ + "img/bulletin-board.47611697.svg";